// extracted by mini-css-extract-plugin
export default {"mCard":"sD-z","image":"tD-z","imageNoBackground":"uD-z","imageHasCategory":"vD-z","fullWidth":"wD-z"};